import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4641b144&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/zklink/web/zklink-explorer-web-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4641b144')) {
      api.createRecord('4641b144', component.options)
    } else {
      api.reload('4641b144', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4641b144&", function () {
      api.rerender('4641b144', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Tip/index.vue"
export default component.exports